import { useEffect, useState } from "react";

const MOBILE_CART_BTN_ID = 'mobileCartBtn';
const BADGE_COUNT_ATTR = 'data-cart-count';

function syncMobileCartBadge(count) {
    const btn = document.getElementById(MOBILE_CART_BTN_ID);
    if (!btn) return;
    if (count > 0) {
        btn.setAttribute(BADGE_COUNT_ATTR, count > 99 ? '99+' : String(count));
    } else {
        btn.removeAttribute(BADGE_COUNT_ATTR);
    }
}

export function BasketHeader(props) {
    const [count, setCount] = useState(Number(props.itemsCount) || 0)

    useEffect(() => {
        setCount(Number(props.itemsCount) || 0);
    }, [props.itemsCount])

    useEffect(() => {
        syncMobileCartBadge(count);
    }, [count]);

    return <>
        <div className="align-center pointer" onClick={e => props.toggleBascket(e, true)} >
            {props.showText ? (
                <span className="underline">{props.showText}</span>
             ) : (
            <>
            <span className="curtains-icon curtains-icon-teenyicons_bag-minus-outline size-24 me-6"></span>
                <span className="caption3">
                    {`Bag ${count > 0 ? `(${count})` : ''} `}
                </span>
            </>
            )}
        </div>
    </>;
}
